export enum CustomerSupportType {
  Ordering,
  Invoices,
  Account,
  ListManagement,
  ParManagement,
  Recipes,
}

export enum OverviewSlideGroups {
  Invoices = 0,
  ARStatements = 1,
  Insights = 2,
  ListManagement = 3,
  NewOrder = 4,
  ImportOrder = 5,
  ItemEntry = 6,
  UserProfile = 7,
  MessageCenter = 8,
  CommunicationsPreferences = 9,
  ParManagement = 10,
  Inventory = 11,
  Recipes = 12,
  OrderEntryAdvancedFilter = 13,
  CatalogSearchAdvancedFilter = 14,
}

export enum ViewStatus {
  NotViewed = 0,
  Viewed = 1,
}
